import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import Box from '@mui/material/Box';
import { StyledDivider, StTextContainer } from '../Subscribe.styles';
import { StDTPGridContainer } from '../../shared/Container/Container.styles';
import { SubscribeProps } from '../Subscribe.types';
import UiHeading from '../../shared/Heading';
import UiSubHeading from '../../shared/Typography/UiSubHeading';

const Resubscribe = (props: SubscribeProps): JSX.Element => {
  if (!props?.fields) return <></>;
  const { heading, content, dividerColor } = props?.fields;

  return (
    <StDTPGridContainer>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        rowGap="2rem"
        sx={{ marginBlock: '2rem' }}
      >
        <UiHeading size="h2" data-testid="title" align="center" color="primary">
          {heading}
        </UiHeading>
        <StyledDivider bgcolor={dividerColor?.value} />
        <StTextContainer>
          <UiSubHeading data-testid="content" align="center" color="default">
            <RichText field={content} />
          </UiSubHeading>
        </StTextContainer>
      </Box>
    </StDTPGridContainer>
  );
};

export default Resubscribe;
